import { Injectable } from '@angular/core';
import { MenuItem } from '../models/menuItem';
import { catchError, map, Observable, of, Subject, switchMap, tap, throwError } from 'rxjs';

import * as _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { DashboardsService } from 'src/app/pages/dashboards/services/dashboards.service';
import { CURRENT_USER_ENDPOINT } from '../config/config.constants';
import {
  DashboardConfig,
  DashboardPosition,
  DashboardType
} from 'src/app/pages/dashboards/models/dashboard-models';
import { Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';
import { saveDashboardConfig } from '../store/actions';
import { DataService } from './data.service';
import { initialStateUser } from '../store/reducers';
import { getMultiLanguageFieldTitle } from 'src/app/shared/customization/multilang-input/multi-language';

import { Vertical } from 'src/app/pages/config/models';
import { position } from 'html2canvas/dist/types/css/property-descriptors/position';
import { ConfigPortalService } from 'src/app/pages/config/config.service';
import { environment } from 'src/environments/environment';
import { getCustomersSelector } from '../store/selectors';
import { AdditionalSignalsScope, MappingConfig } from '../models/iotAssetsModel.data';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationsService {
  onChangeMenuOrder: Subject<MenuItem[]> = new Subject<MenuItem[]>();
  resetUserInfo: Subject<void> = new Subject<void>();

  private readonly apiUrl = environment.baseTsOhwUrl;
  private readonly configEndpoint = 'v1/rt/config/general';

  userInfo: any;
  verticalConfig: Vertical;
  private cachedBasicDashboardChildren: any[] = [];
  homePageDashboard: DashboardConfig | null = null;
  machineDashboardMenu = {
    label: 'machineDashboard',
    w: false,
    child: [],
    order: 700
  }
  customerId: string = '';

  environment = environment.environmentName;
  /* cmaChilds: string[] = [
    'a34318ef-7c14-4589-9786-4d1b729992fb', '1febaa7d-e994-4c08-a1fa-56a2db245e98', '1306c351-4bbd-4c0e-a81d-982e9de7e497', '334e2667-9e05-4267-9dc2-949abc97d6c8', '16276383-52bc-484b-a804-cbc9135dbcef', '0cd131e3-f804-438c-954f-ac99aefa62f0', '4dc11995-6aeb-4b2b-9e2f-16d7db9d622c', '743b15d5-3d87-420a-be71-de17aeb5f1f8', '4922aa6a-6f8e-47c3-8080-b7e60cdad688', '2a135372-6eca-4de6-be6c-8df5a8d46e0a', 'a7f9c16b-c07a-4078-b862-f8885fe858ef', '53f75550-4e1d-45f5-8245-45b8ab09ca93', '8c14c03a-4cc6-4bfc-b987-dd59f0954288', 'fd6c0fd0-eed1-48fa-8850-9f5e193c8b4e', '200c53b1-4487-4464-be7f-3ea418846b8e', '1c34279d-ce92-4472-8686-75f79eac1158', '57aabd88-f3fb-49b4-9fc1-5bf8c4ba75ed', 'f20237d2-500d-406e-bf70-c4124c86b373', 'ed879ae9-26ab-46d3-9674-1e118a1cb12f', 'e6fef854-c1ed-4f56-a75e-5c080deeb82c', '8051f38e-5501-4337-a9d5-0c4ee7676659', '648dc28f-c52a-4d2e-a15d-05449cbf039e', '52f94d22-ee44-4172-bd76-a21ec3bef6fe', 'ab37d605-09da-466c-ac07-aa1d5a734127', '67afa0a7-5a6d-47b0-8bf5-0c996e6f34ca', '9660f90d-6ace-4835-86fd-c3f538257e0f', '95f56b96-3fe2-439b-b0c0-e87435a2d31c', 'f44910a5-cefd-4b5c-8a8b-e60a60fee7f2', '49779325-6a33-4540-906d-f1d3d0025678', 'ebd9c677-d30b-4171-a1a4-603be1e0cd61', 'db325430-8928-4c4a-a318-f199cebf11aa', '268e827e-7d71-45d8-ab14-218356db25d9', 'ab7d5727-f461-458c-8381-49e0f2248444', '87f0d8eb-2ed8-47e1-9faf-68a65ad500b8', 'f0c8c4d5-0d45-4fb0-a500-fbefce99c4c8', 'b4b788c9-5b15-4b4b-a7fa-47ac8bdc4328', '1ef92600-d0be-4024-83f0-eff3fb5bc048'
  ]; */

  constructor(
    private _dashboardService: DashboardsService,
    private _store: Store<AppStateInterface>,
    public dataService: DataService,
    private _configPortalService: ConfigPortalService,
    private http: HttpClient
  ) {
    this.resetUserInfo.subscribe(() => {
      this.userInfo = null;
      this.homePageDashboard = null;
    });

    /* this._store.select(getCustomersSelector).subscribe((customers) => {
      this.cmaChilds = customers.filter((c: any) => c.uidParent === 'fa4d7f05-a54b-4bf0-b24c-243e528f6049')
        .map((c: any) => c.uid);
      console.log('CMA childs updated:', this.cmaChilds);
    }); */
  }

  getUserMenuConfig(): MenuItem[] {
    if (!this.userInfo) {
      this.userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    }

    let orderedMenu = _.orderBy(this.userInfo.menu, ['customOrder', 'order'], ['asc']);

     // TODO: rimuovere quando il BE espone le voci nel menu utente
    // if (!orderedMenu.find(m => m.label === 'consumptionTrend20')) {
    //   orderedMenu.push({ label: 'consumptionTrend20', w: true, order: 999, child: [] });
    // }
    // if (!orderedMenu.find(m => m.label === 'home20')) {
    //   orderedMenu.push({ label: 'home20', w: true, order: 998, child: [] });
    // }

    return orderedMenu;
  }

  /**
   * Recupera l'ordine del menu personalizzato salvato dall'utente sul backend (scope MENU_CONFIG).
   * In caso di assenza di configurazione salvata o di errore, ricade sul menu base (userInfo.menu).
   */
  getUserMenuConfigFromAPI(audience: 'USER' | 'CUSTOMER' | 'GLOBAL' = 'USER'): Observable<MenuItem[]> {
    const baseMenu = this.getUserMenuConfig();

    const uidUser = this.userInfo?.user?.uid;
    const customerUid = this.customerId || this.userInfo?.user?.uidCustomer || this.userInfo?.customer?.uid;

    if (!customerUid || !uidUser) {
      console.warn('Impossibile recuperare menu da API: mancano credenziali', { uidCustomer: !!customerUid, uidUser: !!uidUser });
      return of(baseMenu);
    }

    const queryString = `?scope=${AdditionalSignalsScope.MENU_CONFIG}&uidUser=${uidUser}&uidCustomer=${customerUid}&audience=${audience}`;
    return this.http.get(`${this.apiUrl}${this.configEndpoint}${queryString}`).pipe(
      map((res: any) => {
        const saved: MappingConfig[] = res?.data || [];
        const latest = this.getLatestMenuConfig(saved);
        const savedMenu: MenuItem[] = latest?.config?.mappingData || [];

        if (!savedMenu.length) {
          return baseMenu;
        }

        // Applica ordine e visibilità salvati sul menu base, così le voci non presenti nel salvataggio non spariscono
        const savedByLabel = new Map(savedMenu.map((m: any) => [m.label, m]));
        const mergedMenu = baseMenu.map((item) => {
          const saved = savedByLabel.get(item.label);
          if (!saved) {
            return item;
          }
          return {
            ...item,
            customOrder: saved.customOrder,
            hidden: saved.hidden
          };
        });

        return _.orderBy(mergedMenu, ['customOrder', 'order'], ['asc']);
      }),
      catchError((error) => {
        console.error('[ConfigurationsService] Errore getUserMenuConfigFromAPI:', error);
        return of(baseMenu);
      })
    );
  }

  /**
   * Il backend non ordina i record per data: seleziona il salvataggio più recente per updatedAt/createdAt.
   */
  private getLatestMenuConfig(configs: MappingConfig[]): MappingConfig | null {
    if (!configs?.length) {
      return null;
    }
    return [...configs].sort((a, b) => {
      const dateA = new Date(a.config?.updatedAt || a.config?.createdAt || 0).getTime();
      const dateB = new Date(b.config?.updatedAt || b.config?.createdAt || 0).getTime();
      return dateB - dateA;
    })[0];
  }

  /**
   * Salva l'ordine del menu personalizzato dall'utente sul backend.
   */
  saveMenuConfiguration(menuItems: MenuItem[], audience: 'USER' | 'CUSTOMER' | 'GLOBAL' = 'USER'): Observable<any> {
    if (!menuItems?.length) {
      console.warn('Nessuna configurazione menu da salvare');
      return of(null);
    }
    return this.saveMenuConfigToAPI(menuItems, audience);
  }

  private saveMenuConfigToAPI(menuItems: MenuItem[], audience: 'USER' | 'CUSTOMER' | 'GLOBAL'): Observable<any> {
    if (!this.userInfo) {
      this.userInfo = JSON.parse(localStorage.getItem('user') || '{}');
    }
    const uidUser = this.userInfo?.user?.uid;
    const customerUid = this.customerId || this.userInfo?.user?.uidCustomer || this.userInfo?.customer?.uid;

    if (!customerUid || !uidUser) {
      console.warn('Impossibile salvare menu: mancano credenziali', { uidCustomer: !!customerUid, uidUser: !!uidUser });
      return of(null);
    }

    // Recupera l'eventuale configurazione esistente per aggiornarla (upsert) invece di crearne una nuova ad ogni salvataggio
    const queryString = `?scope=${AdditionalSignalsScope.MENU_CONFIG}&uidUser=${uidUser}&uidCustomer=${customerUid}&audience=${audience}`;
    return this.http.get(`${this.apiUrl}${this.configEndpoint}${queryString}`).pipe(
      switchMap((res: any) => {
        const existing = this.getLatestMenuConfig(res?.data || []);

        const payload: MappingConfig = {
          ...(existing?.id ? { id: existing.id } : {}),
          uidUser,
          scope: AdditionalSignalsScope.MENU_CONFIG,
          audience,
          config: {
            name: 'Menù Configuration',
            description: 'Menù dinamico',
            mappingData: menuItems,
            state: 'active',
            type: 'menu',
            updatedAt: new Date().toISOString(),
            createdAt: existing?.config?.createdAt || new Date().toISOString(),
            customers: [customerUid],
          },
        };

        return this.http.post(`${this.apiUrl}${this.configEndpoint}`, payload);
      }),
      tap(() => console.log('✅ [ConfigurationsService] Configurazione menu salvata')),
      catchError((error) => {
        console.error('[ConfigurationsService] Errore salvataggio menu:', error);
        return throwError(() => error);
      })
    );
  }

  getVerticalConfig(verticalType: string) {
    if (!this.userInfo) {
      this.userInfo = JSON.parse(localStorage.getItem('user') || 'null');
    }
    return this.userInfo ? this._configPortalService.getVerticalConfig(verticalType, this.userInfo.customer.uid, this.userInfo.user.uid).pipe(
      map((res) => {
        this.verticalConfig = res.data[0];
        return res;
      }),
      catchError((err) => {
        return of(null);
      })
    ) : of(initialStateUser);
  }

  /**
   * Fetches and updates the dashboard configuration for a given customer and user.
   *
   * @param customerId - The customer ID to fetch dashboards for
   * @param userId - The user ID to fetch dashboards for
   * @param menuId - The index of the dashboard menu in the user menu array
   * @returns An Observable that emits the user information after updating dashboards
   */
  fetchAndUpdateDashboards(customerId: string, userId: string, menuId?: number) {
    if (!menuId) menuId = this.userInfo.menu.findIndex(
      (m) => m.label === 'newCustomDashboardColl'
    );
    return this._dashboardService
      .getDashboardsConfig(customerId, userId)
      .pipe(
        map((res) => {
          this._store.dispatch(saveDashboardConfig({ dashboards: res }));
          this.setDashboardMenuList(res);
          return { user: this.userInfo };
        }),
        catchError(() => {
          return of({ user: this.userInfo });
        })
      );
  }

  /**
   * Checks and manages the dashboard grant for the current user, ensuring the dashboard menu entry exists.
   * If the dashboard menu entry is missing, it adds a default entry to the user's menu.
   * Then, if the selected customer differs from the current customer, it fetches the dashboard configuration
   * for the specified customer and user, updates the store with the new configuration, and updates the dashboard menu.
   * Handles errors by resetting the dashboard menu entry's children to a basic configuration.
   *
   * @param selectedCustomer - (Optional) The customer ID to check the dashboard grant for. If not provided, uses the current customer ID.
   * @returns An Observable that emits an object containing the updated user information and the home page dashboard,
   *          or the user information in case of an error. Returns `undefined` if no update is necessary.
   */
  checkDashboardGrant(selectedCustomer?: string) {
    let canViewCreatedDashboard: boolean = false;
    if (!this.userInfo || JSON.stringify(this.userInfo) === '{}') {
      this.userInfo = JSON.parse(localStorage.getItem('user') || 'null');
    }
    // This situation is possible when the user logged out
    if (!this.userInfo) {
      return of(initialStateUser);
    }
    let id = this.userInfo.menu.findIndex(
      (m) => m.label === 'newCustomDashboardColl'
    );
    if (id === -1) {
      return of({ user: this.userInfo });
    } else {

      canViewCreatedDashboard = this.userInfo?.user?.group
        ?.features.find(f => f.name === 'newCustomDashboardColl')
        ?.functionalities.find(ff => ff.name === 'viewNewCustomDashboard')?.settings.enabled || false;
      // Extract only the native item since the dashboard will be added afterwards
      this.userInfo.menu = this.userInfo.menu.filter((m) => m.name !== 'dashboard');

      // To remove when get menu is added
      const mId = this.userInfo.menu.findIndex(
        (m) => m.label === 'machineDashboard'
      );
      if (mId === -1 && canViewCreatedDashboard)
        this.userInfo.menu.push(this.machineDashboardMenu);
    }
    // To remove this group of if when with the grant the menu will be given by backend
    // Dashboard menu seen by Actia, CMA and Faresin
    /* if (id === -1 &&
      (this.userInfo.customer?.uid === '12c57878-31e9-46f7-8b4a-8152ae29c57e' // Actia
        || (this.userInfo.customer?.uid === 'fa4d7f05-a54b-4bf0-b24c-243e528f6049' || this.cmaChilds.includes(this.userInfo.customer?.uid)) //CMA
        || (this.userInfo.customer?.uid === 'b6d15851-45ca-47e3-807b-42d05ed700ce' && this.environment !== 'prod')) // Faresin
      ) {
      this.userInfo.menu.push(this.basicDashboardChildMenu);
      this.userInfo.menu.push(this.machineDashboardMenu);
      id = this.userInfo.menu.length - 2;
    } else {
      this.userInfo.menu = this.userInfo.menu.filter((m) => m.name !== 'dashboard');
      const mId = this.userInfo.menu.findIndex(
        (m) => m.label === 'machineDashboard'
      );
      if (mId === -1)
        this.userInfo.menu.push(this.machineDashboardMenu);
    } */
    // Map menu seen by Actia and Faresin
    /* if (this.userInfo.menu.findIndex((m: any) => m.label === 'actiaMap') === -1 &&
      (this.userInfo.customer?.uid === '12c57878-31e9-46f7-8b4a-8152ae29c57e' // Actia
        || this.userInfo.customer?.uid === 'b6d15851-45ca-47e3-807b-42d05ed700ce') // Faresin
      ) {
      this.userInfo.menu.push({ label: 'actiaMap', w: true, child: Array(0), order: 999 });
    } */
    // Reports menu seen by Actia
    /* if (!this.userInfo.menu.some((item) => item.label === 'reports') &&
      (this.userInfo.customer?.uid === '12c57878-31e9-46f7-8b4a-8152ae29c57e') // Actia
    ) {
      const reportsMenuItem = {
        child: [],
        label: "reports",
        order: 450,
        w: false
      };
      this.userInfo.menu.push(reportsMenuItem);
    } */

    if (!canViewCreatedDashboard || id === -1 || this.customerId === selectedCustomer) {
      return of({ user: this.userInfo });
    }

    this.customerId = selectedCustomer || this.customerId;
    return this.fetchAndUpdateDashboards(
      this.customerId || this.userInfo.user?.uidCustomer!,
      this.userInfo.user?.uid!,
      id
    );
  }

  /**
   * Updates the dashboard menu structure for the current user based on the provided dashboard configurations.
   *
   * This method processes the given dashboard configuration array (`res`) and organizes dashboards into menu items
   * and inner page dashboards, updating the user's menu accordingly. It also sets the home page dashboard if present.
   * After updating the menu, it notifies relevant services of the change.
   *
   * @remarks
   * - Dashboards with `DashboardPosition.INNERPAGE` are added as child menu items.
   * - Dashboards with `DashboardPosition.MENUITEM` are added as top-level menu items.
   * - The home page dashboard is set if a dashboard with `DashboardPosition.HOMEPAGE` exists.
   * - The method updates the user's menu and notifies both the data service and dashboard service of the changes.
   */
  setDashboardMenuList(dashboardsList: any) {
    const id = this.userInfo.menu.findIndex(
      (m: any) => m.label === 'newCustomDashboardColl'
    );

    if (this.cachedBasicDashboardChildren.length === 0) {
      this.cachedBasicDashboardChildren = this.userInfo.menu[id].child.filter((c: any) =>
        c.label === 'addNewCustomDashboard' || c.label === 'adminDashboard'
      );
    }

    // Reset the child menu to only include the basic dashboard collection items
    // Since it is entirely rebuilt below
    this.userInfo.menu[id].child = this.cachedBasicDashboardChildren;

    // Add inner page dashboards as child menu items of dashboard menu entry
    const innerDashboards: any = dashboardsList
      .filter((d) => d.config.position === DashboardPosition.INNERPAGE)
      .map((d) => {
        return {
          id: d.id,
          name: 'dashboard',
          label: getMultiLanguageFieldTitle(d.config.name),
          cssClass: getMultiLanguageFieldTitle(d.config.name).replace(/ /g, '-').toLowerCase(),
          type: d.config.type,
          dataType: d.config.dashboardDataType,
          child: []
        };
      });
    // Add menu item dashboards as top-level menu items
    let menuDashboards: any = dashboardsList
      .filter((d) => (d.config.position === DashboardPosition.MENUITEM || d.config.position === DashboardPosition.HOMEPAGE))
      .map((d) => {
        return {
          id: d.id,
          label: getMultiLanguageFieldTitle(d.config.name),
          cssClass: getMultiLanguageFieldTitle(d.config.name).replace(/ /g, '-').toLowerCase(),
          icon: d.config.icon || 'dashboard',
          type: d.config.type,
          dataType: d.config.dashboardDataType,
          name: 'dashboard',
          position: d.config.position,
          child: []
        };
      });
    if (innerDashboards.length > 0) {
      if (this.userInfo.menu[id]) {
        this.userInfo.menu[id].child = [
          ...(this.cachedBasicDashboardChildren || []),
          ...innerDashboards
        ];
      }
    } else {
      if (this.userInfo.menu[id]) {
        this.userInfo.menu[id].child = [
          ...(this.cachedBasicDashboardChildren || [])
        ];
      }
    }
    if (menuDashboards.length > 0) {
      let homePages = menuDashboards.filter(d => d.position === DashboardPosition.HOMEPAGE) || null;
      const homePage = homePages && homePages.length > 0
        ? (homePages.find(h => h.type === DashboardType.CUSTOMER) ||
        homePages.find(h => h.type === DashboardType.ALL_MY_CUSTOMERS))
        : null;
      menuDashboards = homePage ? menuDashboards.filter(d => d.id !== homePage.id) : menuDashboards;
      this.homePageDashboard = homePage;

      menuDashboards.forEach((el) => {
        if (this.userInfo.menu.findIndex((m: any) => m.id === el.id) === -1) {
          this.userInfo.menu.push({ ...el });
        }
      });

      if (homePage) {
        const index = this.userInfo.menu.findIndex((m: any) => m.id === homePage.id);
        homePage.customOrder = 0;
        this.userInfo.menu.unshift(homePage);

        // Remove duplicate entry if existed (in case of menu item set as homepage)
        index === -1 ? null : this.userInfo.menu.splice(index + 1, 1);
      }
    }

    const ind = this.userInfo.menu.findIndex(
      (m: any) => m.label === 'newCustomDashboardColl'
    );
    /* if (this.userInfo.user?.group?.isAdminGroup) {
      if (ind !== -1 && this.userInfo.menu[ind].child.findIndex((c: any) => c.label === 'admin') === -1){
        this.userInfo.menu[ind].child.splice(1, 0, {
          label: 'admin',
          w: false,
          child: [],
          order: 500
        });
      }
    } */

    /* let homePages = dashboardsList.filter(d => d.config.position === DashboardPosition.HOMEPAGE) || null;
    const homePage = homePages && homePages.length > 0
      ? (homePages.find(h => h.config.type === DashboardType.CUSTOMER) ||
       homePages.find(h => h.config.type === DashboardType.ALL_MY_CUSTOMERS))
      : null;
    homePages = homePages && homePages.length > 0 ? homePages.filter(h => h.id !== homePage.id) : null;

    this.homePageDashboard = homePage;
    // Set home page dashboard as first menu entry
    if (homePage) {
      const index = this.userInfo.menu.findIndex((m: any) => m.id === homePage.id);
      this.userInfo.menu.unshift({
        id: homePage.id,
        label: getMultiLanguageFieldTitle(homePage.config.name),
        cssClass: getMultiLanguageFieldTitle(homePage.config.name).replace(/ /g, '-').toLowerCase(),
        icon: homePage.config.icon || 'dashboard',
        name: 'dashboard',
        type: homePage.config.type,
        customOrder: 0,
        child: [],
        // hidden: homePage.config.hidden
      });
      // Remove duplicate entry if existed (in case of menu item set as homepage)
      index === -1 ? null : this.userInfo.menu.splice(index + 1, 1);
    } */

    // To remove with grants for cma
    /* if (ind !== -1 && this.cmaChilds.includes(this.userInfo.customer?.uid)) {
      const newInd = this.userInfo.menu[ind].child.findIndex((c: any) => c.label === 'addNewCustomDashboard');
      if (newInd !== -1) {
        this.userInfo.menu[ind].child.splice(newInd, 1);
      }
      if (innerDashboards.length === 0) {
        this.userInfo.menu.splice(ind, 1);
      }
    } */

    this.dataService.setCurrentUserInfo(this.userInfo);
    this._dashboardService.dashboardMenuUpdated$.next(null);
  }


  /**
   * Updates the user menu and dashboards list based on dashboard changes (creation, editing, or deletion).
   *
   * @param event - An object containing the dashboard configuration and the action performed ('new', 'edit', or 'delete').
   * @param dashboardsList - The current list of dashboards to be updated.
   * @returns An object containing the updated dashboards list (`dl`) and the updated user info (`ui`).
   *
   * @remarks
   * - When a new dashboard is added, it is inserted into the appropriate menu location and appended to the dashboards list.
   * - When a dashboard is edited, both the menu and dashboards list are updated to reflect the changes.
   * - When a dashboard is deleted, it is removed from both the menu and dashboards list.
   * - The method updates the `userMenu` and synchronizes it with `userInfo.menu`.
   */
  updateMenuListOnDashboardChange(
    event: { dashboard: DashboardConfig; action: 'new' | 'edit' | 'duplicate' | 'delete' },
    dashboardsList: any[],
  ): { dl: DashboardConfig[]; ui: any } {
    // Create mutable copy of dashboardsList from store
    const mutableDashboardsList = _.cloneDeep(dashboardsList);
    const dashboard = event.dashboard;
    const oldPositionIndex = this.userInfo.menu.findIndex((m: any) => m.id === dashboard.id);
    const newPosition = dashboard.config.position;
    const dashboardListIndex = mutableDashboardsList.findIndex((d: any) => d.id === dashboard.id);

    switch (event.action) {
      case 'new':
        mutableDashboardsList.push(dashboard);
        break;
      case 'edit':
        if (oldPositionIndex !== -1 && newPosition === DashboardPosition.INNERPAGE) {
          this.userInfo.menu.splice(oldPositionIndex, 1);
        }
        if (dashboardListIndex !== -1) {
          mutableDashboardsList[dashboardListIndex] = dashboard;
        }
        break;
      case 'duplicate':
        mutableDashboardsList.push(dashboard);
        break;
      case 'delete':
        if (oldPositionIndex !== -1) {
          this.userInfo.menu.splice(oldPositionIndex, 1);
        }
        if (dashboardListIndex !== -1) {
          mutableDashboardsList.splice(dashboardListIndex, 1);
        }
        break;
    }

    this.setDashboardMenuList(mutableDashboardsList);
    return { dl: mutableDashboardsList, ui: this.userInfo };
  }

}
